import React from "react";

/**
 * JsonLd — inject structured data for SEO.
 * Usage: <JsonLd data={{...}} />
 */
export function JsonLd({ data }) {
  if (!data) return null;
  const json = JSON.stringify(data).replace(/</g, "\\u003c");
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}

export const PERSON_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Dan Ryder",
  alternateName: "xaelserpent",
  url: "https://www.xaelserpent.com",
  image: "https://www.xaelserpent.com/yellow.png",
  sameAs: [
    "https://www.twitch.tv/xaelserpent",
    "https://www.kick.com/xaelserpent",
    "https://www.youtube.com/xaelserpent",
    "https://www.x.com/xaelserpent",
    "https://www.facebook.com/xaelserpent",
  ],
};

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "xaelserpent",
  alternateName: "xaelserpent | lightning power",
  url: "https://www.xaelserpent.com",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.xaelserpent.com/?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

export function articleSchema(post, origin = "https://www.xaelserpent.com") {
  if (!post) return null;
  const image = post.cover_image_url
    ? (post.cover_image_url.startsWith("http") ? post.cover_image_url : `${origin}${post.cover_image_url}`)
    : `${origin}/yellow.png`;
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: post.title,
    description: post.seo_description || post.excerpt || "",
    image: [image],
    datePublished: post.published_at,
    dateModified: post.updated_at,
    author: PERSON_SCHEMA,
    publisher: {
      "@type": "Organization",
      name: "xaelserpent.com",
      logo: { "@type": "ImageObject", url: `${origin}/yellow.png` },
    },
    mainEntityOfPage: { "@type": "WebPage", "@id": `${origin}/articles/${post.slug}` },
    keywords: (post.tags || []).join(", "),
    identifier: post.blockchain_hash,
  };
}
